export default {"src":"/_next/static/media/flexibleBackups.409cc4b0.svg","height":32,"width":34};